import { TermsAndConditions, TermsAndConditionsConfig as TermsAndConditionsConfigT } from '@ua-okta-ui/types'

export const DEFAULT_TERMS_AND_CONDITIONS: TermsAndConditions = {
	'enroll-profile':
		"By creating an account and joining UA Rewards, you agree to [UA Rewards' Terms & Conditions](https://help.underarmour.com/s/article/UA-Rewards-Terms-and-Conditions)" +
		" and Under Armour's [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy)" +
		' and [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US).',

	identify:
		"By logging in, you agree to [UA Rewards' Terms & Conditions](https://help.underarmour.com/s/article/UA-Rewards-Terms-and-Conditions)" +
		" and Under Armour's [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy)" +
		' and [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US).',

	'identify-recovery':
		"By resetting your password, you agree to [UA Rewards' Terms & Conditions](https://help.underarmour.com/s/article/UA-Rewards-Terms-and-Conditions)" +
		" and Under Armour's [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy)" +
		' and [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US).',
}

export const TermsAndConditionsConfig: TermsAndConditionsConfigT = {
	regions: {
		//#region North America
		'en-us': DEFAULT_TERMS_AND_CONDITIONS,
		'en-ca': {
			'enroll-profile':
				"By creating an account, you agree to Under Armour's [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US)" +
				' and [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US).',

			identify:
				'By logging in, you agree to the [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US)' +
				' and [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US).',

			'identify-recovery':
				'By resetting your password, you agree to the [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US)' +
				' and [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US).',
		},
		'es-mx': {
			'enroll-profile':
				'Al registrarte, aceptas los [Términos y condiciones](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=es_MX)' +
				' y la [Política de privacidad](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=es_MX).',

			identify:
				'Al iniciar sesión, aceptas los [Términos y condiciones](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=es_MX)' +
				' y la [Política de privacidad](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=es_MX).',

			'identify-recovery':
				'Si restableces tu contraseña, aceptas los [Términos y condiciones](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=es_MX)' +
				' y la [Política de privacidad](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=es_MX).',
		},
		'fr-ca': {
			'enroll-profile':
				"En créant un compte, vous acceptez Under Armour's [Politique de confidentialité](https://privacy.underarmour.com/s/topic/0TO4V00000110aRWAQ/privacy-policy?language=fr)" +
				' et [Modalités](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=fr_CA).',
			identify:
				'En vous connectant, vous acceptez le [Modalités](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=fr_CA)' +
				' et [Politique de confidentialité](https://privacy.underarmour.com/s/topic/0TO4V00000110aRWAQ/privacy-policy?language=fr).',

			'identify-recovery':
				"En réinitialisant votre mot de passe, vous acceptez Under Armour's [Politique de confidentialité](https://privacy.underarmour.com/s/topic/0TO4V00000110aRWAQ/privacy-policy?language=fr)" +
				' et [Modalités](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=fr_CA).',
		},
		//#endregion
		//#region EMEA
		'de-at': {
			identify:
				'Mit Ihrer Anmeldung stimmen Sie unseren [Nutzungsbeding ungen](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=de)' +
				' und [Datenschutzerklärung](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=de)' +
				' zu.',
			'enroll-profile':
				'Mit der Erstellung eines Kontos stimmen Sie den [Nutzungsbedingungen](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=de)' +
				' und der [Datenschutzerklärung](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=de)' +
				' zu.',

			'identify-recovery':
				'Durch das Zurücksetzen deines Passworts stimmen Sie den [Nutzungsbedingungen](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=de)' +
				' und der [Datenschutzerklärung](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=de)' +
				' zu.',
		},
		'de-ch': {
			identify:
				'Mit Ihrer Anmeldung stimmen Sie unseren [Nutzungsbeding ungen](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=de)' +
				' und [Datenschutzerklärung](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=de)' +
				' zu.',
			'enroll-profile':
				'Mit der Erstellung eines Kontos stimmen Sie den [Nutzungsbedingungen](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=de)' +
				' und der [Datenschutzerklärung](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=de)' +
				' zu.',

			'identify-recovery':
				'Durch das Zurücksetzen deines Passworts stimmen Sie den [Nutzungsbedingungen](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=de)' +
				' und der [Datenschutzerklärung](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=de)' +
				' zu.',
		},
		'de-de': {
			identify:
				'Mit Ihrer Anmeldung stimmen Sie unseren [Nutzungsbeding ungen](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=de)' +
				' und [Datenschutzerklärung](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=de)' +
				' zu.',
			'enroll-profile':
				'Mit der Erstellung eines Kontos stimmen Sie den [Nutzungsbedingungen](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=de)' +
				' und der [Datenschutzerklärung](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=de)' +
				' zu.',

			'identify-recovery':
				'Durch das Zurücksetzen deines Passworts stimmen Sie den [Nutzungsbedingungen](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=de)' +
				' und der [Datenschutzerklärung](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=de)' +
				' zu.',
		},
		'en-at': {
			identify:
				'By logging in, you agree to the [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US)' +
				' and [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US).',
			'enroll-profile':
				'By creating an account, you agree to Under Armour’s [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US)' +
				' and [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US).',

			'identify-recovery': ' ',
		},
		'en-be': {
			identify:
				'By logging in, you agree to the [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US)' +
				' and [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US).',
			'enroll-profile':
				'By creating an account, you agree to Under Armour’s [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US)' +
				' and [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US).',

			'identify-recovery': ' ',
		},
		'en-ch': {
			identify:
				'By logging in, you agree to the [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US)' +
				' and [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US).',
			'enroll-profile':
				'By creating an account, you agree to Under Armour’s [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US)' +
				' and [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US).',

			'identify-recovery': ' ',
		},
		'en-de': {
			identify:
				'By logging in, you agree to the [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US)' +
				' and [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US).',
			'enroll-profile':
				'By creating an account, you agree to Under Armour’s [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US)' +
				' and [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US).',

			'identify-recovery': ' ',
		},
		'en-dk': {
			identify:
				'By logging in, you agree to the [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US)' +
				' and [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US).',
			'enroll-profile':
				'By creating an account, you agree to Under Armour’s [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US)' +
				' and [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US).',

			'identify-recovery': ' ',
		},
		'en-es': {
			identify:
				'By logging in, you agree to the [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US)' +
				' and [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US).',
			'enroll-profile':
				'By creating an account, you agree to Under Armour’s [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US)' +
				' and [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US).',

			'identify-recovery':
				'By resetting your password, you agree to the [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US)' +
				' and [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US).',
		},
		'en-fr': {
			identify:
				'By logging in, you agree to the [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US)' +
				' and [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US).',
			'enroll-profile':
				'By creating an account, you agree to Under Armour’s [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US)' +
				' and [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US).',

			'identify-recovery':
				'By resetting your password, you agree to the [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US)' +
				' and [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US).',
		},
		'en-gb': {
			identify:
				'By logging in, you agree to the [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US)' +
				' and [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US).',
			'enroll-profile':
				'By creating an account, you agree to Under Armour’s [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US)' +
				' and [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US).',

			'identify-recovery':
				'By resetting your password, you agree to the [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US)' +
				' and [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US).',
		},
		'en-ie': {
			identify:
				'By logging in, you agree to the [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US)' +
				' and [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US).',
			'enroll-profile':
				'By creating an account, you agree to Under Armour’s [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US)' +
				' and [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US).',

			'identify-recovery': ' ',
		},
		'en-it': {
			identify:
				'By logging in, you agree to the [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US)' +
				' and [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US).',
			'enroll-profile':
				'By creating an account, you agree to Under Armour’s [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US)' +
				' and [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US).',

			'identify-recovery':
				'By resetting your password, you agree to the [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US)' +
				' and [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US).',
		},
		'en-nl': {
			identify:
				'By logging in, you agree to the [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US)' +
				' and [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US).',
			'enroll-profile':
				'By creating an account, you agree to Under Armour’s [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US)' +
				' and [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US).',

			'identify-recovery':
				'By resetting your password, you agree to the [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US)' +
				' and [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US).',
		},
		'en-no': {
			identify:
				'By logging in, you agree to the [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US)' +
				' and [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US).',
			'enroll-profile':
				'By creating an account, you agree to Under Armour’s [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US)' +
				' and [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US).',

			'identify-recovery': ' ',
		},
		'en-pl': {
			identify:
				'By logging in, you agree to the [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US)' +
				' and [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US).',
			'enroll-profile':
				'By creating an account, you agree to Under Armour’s [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US)' +
				' and [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US).',

			'identify-recovery':
				'By resetting your password, you agree to the [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US)' +
				' and [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US).',
		},
		'en-pt': {
			identify:
				'By logging in, you agree to the [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US)' +
				' and [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US).',
			'enroll-profile':
				'By creating an account, you agree to Under Armour’s [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US)' +
				' and [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US).',

			'identify-recovery': ' ',
		},
		'en-se': {
			identify:
				'By logging in, you agree to the [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US)' +
				' and [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US).',
			'enroll-profile':
				'By creating an account, you agree to Under Armour’s [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US)' +
				' and [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US).',

			'identify-recovery': ' ',
		},
		'es-es': {
			identify:
				'Al proporcionar tu correo electrónico, aceptas los [Términos de uso](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=es)' +
				' y [la Política de privacidad](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=es).',
			'enroll-profile':
				'Al crear una cuenta, aceptas [la Política de privacidad](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=es)' +
				' y los [Términos de uso](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=es).',

			'identify-recovery':
				'Al restablecer tu contraseña, aceptas los [Términos de uso](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=es)' +
				' y [la Política de privacidad](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=es).',
		},
		'fr-be': {
			identify:
				'En vous connectant, vous acceptez les [conditions générales](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=fr)' +
				' et la [politique de confidentialité](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=fr).',
			'enroll-profile':
				'En créant un compte, vous acceptez la [politique de confidentialité](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=fr)' +
				" et les [conditions générales](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=fr) d'Under Armour.",

			'identify-recovery':
				'En réinitialisant ton mot de passe, vous acceptez les [conditions générales](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=fr)' +
				' et la [politique de confidentialité](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=fr).',
		},
		'fr-ch': {
			identify:
				'En vous connectant, vous acceptez les [conditions générales](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=fr)' +
				' et la [politique de confidentialité](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=fr).',
			'enroll-profile':
				'En créant un compte, vous acceptez la [politique de confidentialité](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=fr)' +
				" et les [conditions générales](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=fr) d'Under Armour.",

			'identify-recovery':
				'En réinitialisant ton mot de passe, vous acceptez les [conditions générales](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=fr)' +
				' et la [politique de confidentialité](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=fr).',
		},
		'fr-fr': {
			identify:
				'En vous connectant, vous acceptez les [conditions générales](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=fr)' +
				' et la [politique de confidentialité](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=fr).',
			'enroll-profile':
				'En créant un compte, vous acceptez la [politique de confidentialité](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=fr)' +
				" et les [conditions générales](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=fr) d'Under Armour.",

			'identify-recovery':
				'En réinitialisant ton mot de passe, vous acceptez les [conditions générales](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=fr)' +
				' et la [politique de confidentialité](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=fr).',
		},
		'it-ch': {
			identify:
				'Accedendo al tuo account, accetti i [Termini & Condizioni](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=it)' +
				' e la [Politica sulla Privacy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=it).',
			'enroll-profile':
				'Creando un account, accetti la [Termini & Condizioni](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=it)' +
				' e i [Politica sulla Privacy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=it)' +
				' di Under Armour.',

			'identify-recovery':
				'Reimpostando la password, accetti i [Termini & Condizioni](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=it)' +
				' e la [Politica sulla Privacy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=it).',
		},
		'it-it': {
			identify:
				'Accedendo al tuo account, accetti i [Termini & Condizioni](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=it)' +
				' e la [Politica sulla Privacy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=it).',
			'enroll-profile':
				'Creando un account, accetti la [Termini & Condizioni](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=it)' +
				' e i [Politica sulla Privacy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=it)' +
				' di Under Armour.',
			'identify-recovery':
				'Reimpostando la password, accetti i [Termini & Condizioni](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=it)' +
				' e la [Politica sulla Privacy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=it).',
		},
		'nl-be': {
			identify:
				'Door in te loggen ga je akkoord met onze [algemene voorwaarden](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=nl_NL)' +
				' en [privacybeleid](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=nl_NL).',
			'enroll-profile':
				'Met het maken van een account, ga je akkoord met onze [algemene voorwaarden](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=nl_NL)' +
				' en [privacybeleid](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=nl_NL).',

			'identify-recovery':
				'Door je wachtwoord opnieuw in te stellen ga je akkoord met onze [algemene voorwaarden](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=nl_NL)' +
				' en [privacybeleid](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=nl_NL).',
		},
		'nl-nl': {
			identify:
				'Door in te loggen ga je akkoord met onze [algemene voorwaarden](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=nl_NL)' +
				' en [privacybeleid](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=nl_NL).',
			'enroll-profile':
				'Met het maken van een account, ga je akkoord met onze [algemene voorwaarden](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=nl_NL)' +
				' en [privacybeleid](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=nl_NL).',

			'identify-recovery':
				'Door je wachtwoord opnieuw in te stellen ga je akkoord met onze [algemene voorwaarden](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=nl_NL)' +
				' en [privacybeleid](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=nl_NL).',
		},
		'pl-pl': {
			identify:
				'Logując się, akceptujesz [Regulamin  &](https://account.underarmour.com/pl-pl/terms-and-conditions?locale=pl_pl)' +
				' i [Politykę prywatności](https://account.underarmour.com/pl-pl/privacy?locale=pl_pl).',
			'enroll-profile':
				'Zakładając konto, akceptujesz [Politykę prywatności](https://account.underarmour.com/pl-pl/privacy?locale=pl_pl)' +
				' i [Regulamin](https://account.underarmour.com/pl-pl/terms-and-conditions?locale=pl_pl) Under Armour™.',

			'identify-recovery':
				'Resetując hasło, akceptujesz [Politykę prywatności](https://account.underarmour.com/pl-pl/privacy?locale=pl_pl)' +
				' i [Regulamin](https://account.underarmour.com/pl-pl/terms-and-conditions?locale=pl_pl) Under Armour™.',
		},
		'pt-pt': {
			identify:
				'By logging in, you agree to the [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US)' +
				' and [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US).',
			'enroll-profile':
				'By creating an account, you agree to Under Armour’s [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US)' +
				' and [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US).',

			'identify-recovery': ' ',
		},
		//#endregion
		//#region APAC
		'en-au': {
			identify:
				'By logging in, you agree to the [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US)' +
				' and [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US).',
			'enroll-profile':
				'By creating an account, you agree to Under Armour’s [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US)' +
				' and [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US).',

			'identify-recovery': ' ',
		},
		'en-hk': {
			identify:
				'<p>By default, your UA.com password will be different from UA Rewards app.</p><br/><p>By logging in, you agree and grant consent to the updated Under Armour Rewards (“UA Rewards”) programme [Terms & Conditions](https://www.underarmour.hk/en-hk/t/ua-rewards-termsandconditions.html)' +
				', [Privacy Policy](https://www.underarmour.hk/en-hk/t/ua-rewards-privacypolicy.html)' +
				'; and Under Armour [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US)' +
				' and [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US).</p>',
			'enroll-profile':
				'<p>By default, your UA.com password will be different from UA Rewards app.</p><br/><p>By creating an account, you agree and grant consent to the updated Under Armour Rewards (“UA Rewards”) programme [Terms & Conditions](https://www.underarmour.hk/en-hk/t/ua-rewards-termsandconditions.html)' +
				', [Privacy Policy](https://www.underarmour.hk/en-hk/t/ua-rewards-privacypolicy.html)' +
				'; and Under Armour [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US)' +
				' and [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US).</p>',

			'identify-recovery':
				'<p>By default, your UA.com password will be different from UA Rewards app.</p><br/><p>By resetting your password, you agree and grant consent to the updated Under Armour Rewards (“UA Rewards”) programme [Terms & Conditions](https://www.underarmour.hk/en-hk/t/ua-rewards-termsandconditions.html)' +
				', [Privacy Policy](https://www.underarmour.hk/en-hk/t/ua-rewards-privacypolicy.html)' +
				'; and Under Armour [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US)' +
				' and [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US).</p>',
		},
		'en-id': {
			identify:
				'By logging in, you agree to the [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US)' +
				' and [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US).',
			'enroll-profile':
				'By creating an account, you agree to Under Armour’s [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US)' +
				' and [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US).',

			'identify-recovery': ' ',
		},
		'en-my': {
			identify:
				'<p>By default, your UA.com password will be different from UA Rewards app.</p><br/><p>By logging in, you agree and grant consent to the updated Under Armour Rewards (“UA Rewards”) programme [Terms & Conditions](https://www.underarmour.com.my/en-my/t/ua-rewards-termsandconditions.html)' +
				', [Privacy Policy](https://www.underarmour.com.my/en-my/t/ua-rewards-privacypolicy.html)' +
				'; and Under Armour [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US)' +
				' and [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US).</p>',
			'enroll-profile':
				'<p>By default, your UA.com password will be different from UA Rewards app.</p><br/><p>By creating an account, you agree and grant consent to the updated Under Armour Rewards (“UA Rewards”) programme [Terms & Conditions](https://www.underarmour.com.my/en-my/t/ua-rewards-termsandconditions.html)' +
				', [Privacy Policy](https://www.underarmour.com.my/en-my/t/ua-rewards-privacypolicy.html)' +
				'; and Under Armour [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US)' +
				' and [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US).</p>',

			'identify-recovery': ' ',
		},
		'en-nz': {
			identify:
				'By logging in, you agree to the [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US)' +
				' and [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US).',
			'enroll-profile':
				'By creating an account, you agree to Under Armour’s [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US)' +
				' and [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US).',

			'identify-recovery': ' ',
		},
		'en-ph': {
			identify:
				'By logging in, you agree to the [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US)' +
				' and [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US).',
			'enroll-profile':
				'By creating an account, you agree to Under Armour’s [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US)' +
				' and [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US).',

			'identify-recovery': ' ',
		},
		'en-sg': {
			identify:
				'<p>By default, your UA.com password will be different from UA Rewards app.</p><br/><p>By logging in, you agree and grant consent to the updated Under Armour Rewards (“UA Rewards”) programme [Terms & Conditions](https://www.underarmour.com.sg/en-sg/t/ua-rewards-termsandconditions.html)' +
				', [Privacy Policy](https://www.underarmour.com.sg/en-sg/t/ua-rewards-privacypolicy.html)' +
				'; and Under Armour [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US)' +
				' and [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US).</p>',
			'enroll-profile':
				'<p>By default, your UA.com password will be different from UA Rewards app.</p><br/><p>By creating an account, you agree and grant consent to the updated Under Armour Rewards (“UA Rewards”) programme [Terms & Conditions](https://www.underarmour.com.sg/en-sg/t/ua-rewards-termsandconditions.html)' +
				', [Privacy Policy](https://www.underarmour.com.sg/en-sg/t/ua-rewards-privacypolicy.html)' +
				'; and Under Armour [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US)' +
				' and [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US).</p>',

			'identify-recovery': ' ',
		},
		'en-th': {
			identify:
				'<p>By default, your UA.com password will be different from UA Rewards app.</p><br/><p>By logging in, you agree and grant consent to the updated Under Armour Rewards (“UA Rewards”) programme [Terms & Conditions](https://www.underarmour.co.th/en-th/t/ua-rewards-termsandconditions.html)' +
				', [Privacy Policy](https://www.underarmour.co.th/en-th/t/ua-rewards-privacypolicy.html)' +
				'; and Under Armour [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US)' +
				' and [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US).</p>',
			'enroll-profile':
				'<p>By default, your UA.com password will be different from UA Rewards app.</p><br/><p>By creating an account, you agree and grant consent to the updated Under Armour Rewards (“UA Rewards”) programme [Terms & Conditions](https://www.underarmour.co.th/en-th/t/ua-rewards-termsandconditions.html)' +
				', [Privacy Policy](https://www.underarmour.co.th/en-th/t/ua-rewards-privacypolicy.html)' +
				'; and Under Armour [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US)' +
				' and [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US).</p>',

			'identify-recovery':
				'<p>By default, your UA.com password will be different from UA Rewards app.</p><br/><p>By resetting your password, you agree and grant consent to the updated Under Armour Rewards (“UA Rewards”) programme [Terms & Conditions](https://www.underarmour.co.th/en-th/t/ua-rewards-termsandconditions.html)' +
				', [Privacy Policy](https://www.underarmour.co.th/en-th/t/ua-rewards-privacypolicy.html)' +
				'; and Under Armour [Privacy Policy](https://privacy.underarmour.com/s/article/Global-Privacy-Policy?language=en_US)' +
				' and [Terms & Conditions](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=en_US).</p>',
		},
		'in-id': {
			identify:
				'Dengan membuat akun, Anda menyetujui [Syarat & Ketentuan Under Armour.](https://account.underarmour.com/en-us/terms-and-conditions?locale=en_us)' +
				' dan [Kebijakan Privasi](https://account.underarmour.com/en-us/privacy?locale=en_us).',
			'enroll-profile':
				'Dengan membuat akun, Anda menyetujui [Syarat & Ketentuan Under Armour.](https://account.underarmour.com/en-us/terms-and-conditions?locale=en_us)' +
				' dan [Kebijakan Privasi](https://account.underarmour.com/en-us/privacy?locale=en_us).',

			'identify-recovery': ' ',
		},
		'ko-kr': {
			identify:
				'로그인하시면 언더아머 [이용 약관](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=ko)' +
				' 및 [개인 정보 처리 방침](https://privacy.underarmour.com/s/article/Residents-of-South-Korea?language=ko)' +
				' 에 동의하게 됩니다.',
			'enroll-profile':
				'이 버튼을 클릭하시면 언더아머 코리아의  [이용약관](https://privacy.underarmour.com/s/topic/0TO4V00000110jEWAQ/terms-and-conditions-of-use?language=ko)' +
				', [개인정보처리방침](https://privacy.underarmour.com/s/article/Residents-of-South-Korea?language=ko)' +
				', 필수 개인정보 처리에 동의한 것으로 간주됩니다.',

			'identify-recovery': ' ',
		},
		'th-th': {
			identify:
				"<p>ด้วยค่าเริ่มต้นเริ่มต้น, รหัสผ่านบนบัญชี UA.com จะแตกต่างจากรหัสผ่านบนบัญชี UA Rewards app</p><br/><p>การเข้าสู่ระบบถือว่าท่านตกลงและยินยอมในการอับเดตโปรแกรม Under Armour Rewards ('UA Rewards') [ข้อตกลงและเงื่อนไข](https://www.underarmour.co.th/th-th/t/ua-rewards-termsandconditions.html)" +
				', [นโยบายความเป็นส่วนตัว](https://www.underarmour.co.th/th-th/t/ua-rewards-privacypolicy.html)' +
				'; และอันเดอร์อาร์มเมอร์ [นโยบายความเป็นส่วนตัว](https://account.underarmour.com/en-us/privacy?locale=en_us)' +
				' และ [ข้อตกลงและเงื่อนไข](https://account.underarmour.com/en-us/terms-and-conditions?locale=en_us).</p>',
			'enroll-profile':
				"<p>ด้วยค่าเริ่มต้นเริ่มต้น, รหัสผ่านบนบัญชี UA.com จะแตกต่างจากรหัสผ่านบนบัญชี UA Rewards app</p><br/><p>การสร้างบัญชีถือว่าท่านตกลงและยินยอมในการอับเดตโปรแกรม Under Armour Rewards ('UA Rewards') [ข้อตกลงและเงื่อนไข](https://www.underarmour.co.th/th-th/t/ua-rewards-termsandconditions.html)" +
				', [นโยบายความเป็นส่วนตัว](https://www.underarmour.co.th/th-th/t/ua-rewards-privacypolicy.html)' +
				'; และอันเดอร์อาร์มเมอร์ [นโยบายความเป็นส่วนตัว](https://account.underarmour.com/en-us/privacy?locale=en_us)' +
				' และ [ข้อตกลงและเงื่อนไข](https://account.underarmour.com/en-us/terms-and-conditions?locale=en_us).</p>',

			'identify-recovery':
				"<p>ด้วยค่าเริ่มต้นเริ่มต้น, รหัสผ่านบนบัญชี UA.com จะแตกต่างจากรหัสผ่านบนบัญชี UA Rewards app</p><br/><p>เมื่อทำการรีเซ็ตรหัสผ่านของคุณท่านตกลงและยินยอมในการอับเดตโปรแกรม Under Armour Rewards ('UA Rewards') [ข้อตกลงและเงื่อนไข](https://www.underarmour.co.th/th-th/t/ua-rewards-termsandconditions.html)" +
				', [นโยบายความเป็นส่วนตัว](https://www.underarmour.co.th/th-th/t/ua-rewards-privacypolicy.html)' +
				'; และอันเดอร์อาร์มเมอร์ [นโยบายความเป็นส่วนตัว](https://account.underarmour.com/en-us/privacy?locale=en_us)' +
				' และ [ข้อตกลงและเงื่อนไข](https://account.underarmour.com/en-us/terms-and-conditions?locale=en_us).</p>',
		},
		'zh-hk': {
			identify:
				'<p>根據默認設定，您的UA.com應與UA Rewards應用使用不同的密碼.</p><br/><p>登入即表示您同意並許可我方同意新版Under Armour Rewards（「UA Rewards」）計劃的 [《條款與條件》](https://www.underarmour.hk/zh-hk/t/ua-rewards-termsandconditions.html)' +
				' 和 [《隱私政策》](https://www.underarmour.hk/zh-hk/t/ua-rewards-privacypolicy.html)' +
				'；及Under Armour [《隱私政策》](https://account.underarmour.com/zh-hk/privacy)' +
				' 和 [《條款與條件》](https://account.underarmour.com/zh-hk/terms-and-conditions).</p>',
			'enroll-profile':
				'<p>根據默認設定，您的UA.com應與UA Rewards應用使用不同的密碼</p><br/><p>創建賬戶即表示您同意並許可我方同意新版Under Armour Rewards（「UA Rewards」）計劃的[《條款與條件》](https://www.underarmour.hk/zh-hk/t/ua-rewards-termsandconditions.html)' +
				' 和 [《隱私政策》](https://www.underarmour.hk/zh-hk/t/ua-rewards-privacypolicy.html)' +
				'；及Under Armour [《隱私政策》](https://account.underarmour.com/zh-hk/privacy)' +
				' 和 [《條款與條件》](https://account.underarmour.com/zh-hk/terms-and-conditions).</p>',

			'identify-recovery':
				'<p>根據默認設定，您的UA.com應與UA Rewards應用使用不同的密碼</p><br/><p>透過重設您的密碼您同意並許可我方同意新版Under Armour Rewards（「UA Rewards」）計劃的[《條款與條件》](https://www.underarmour.hk/zh-hk/t/ua-rewards-termsandconditions.html)' +
				' 和 [《隱私政策》](https://www.underarmour.hk/zh-hk/t/ua-rewards-privacypolicy.html)' +
				'；及Under Armour [《隱私政策》](https://account.underarmour.com/zh-hk/privacy)' +
				' 和 [《條款與條件》](https://account.underarmour.com/zh-hk/terms-and-conditions).</p>',
		},
		//#endregion
	},

	overrides: {
		'uk-next': {
			'en-gb': {
				identify:
					'By logging in, you agree to the [Terms & Conditions](https://www.underarmournext.co.uk/terms-and-conditions)' +
					' and [Privacy Policy](https://account.underarmour.com/en-us/privacy?locale=en_us).',
				'enroll-profile':
					'By creating an account, you agree to Under Armour’s [Privacy Policy](https://account.underarmour.com/en-us/privacy?locale=en_us)' +
					' and [Terms & Conditions](https://www.underarmournext.co.uk/terms-and-conditions).',

				'identify-recovery': ' ',
			},
		},
	},
}
